import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';
import { WxLabel } from '../..';
import useMenu from '../../../hooks/api/queries/useMenu';
import { breakpoint } from '../../../styles/constants';
import { appendCommitHash } from '../../../utils/appendHash';
import { constructBreadcrumbs } from '../../../utils/constructSlug';

type Props = { categorySlug: string; lastClickable?: boolean };

export const CategoryBreadCrumb = ({
  categorySlug,
  lastClickable = false,
}: Props) => {
  const { data } = useMenu();

  if (!data) return null;

  const breadcrumbs = constructBreadcrumbs(data, categorySlug);

  return (
    <Container>
      {breadcrumbs?.map(({ label, slug }, index) => (
        <React.Fragment key={`${index}-cat-crumb`}>
          <li>
            <StyledLink
              to={appendCommitHash(slug)}
              disabled={!lastClickable && index === breadcrumbs.length - 1}
            >
              <WxLabel
                label={label}
                hover={index !== breadcrumbs.length - 1}
                active={index === breadcrumbs.length - 1}
                small
              />
            </StyledLink>
          </li>
          {index !== breadcrumbs.length - 1 && (
            <li>
              <FontAwesomeIcon icon={faChevronRight} size={'sm'} />
            </li>
          )}
        </React.Fragment>
      ))}
    </Container>
  );
};

const StyledLink = styled(Link)<{ disabled: boolean }>`
  ${({ disabled }) => disabled && 'pointer-events: none;'}
`;

const Container = styled.ul`
  display: none;

  @media (min-width: ${breakpoint}) {
    display: flex;
    align-items: center;
    margin-top: 0.875rem;
    margin-bottom: 0.625rem;
    gap: 0.25rem;
  }

  li,
  p {
    font-size: 0.5rem;
    color: ${({ theme }) => theme.colors.breadcrumb};
  }
`;
